<template>

  <div class="img_preview_wrap">
    <div class="img_preview_box">
      <div class="img_head">
        <p class="img_name">{{imgName}}</p>
        <span class="el-icon-circle-close close_btn" @click="closeFn()"></span>
      </div>
      <div class="img-box">
        <!-- 过渡动画 -->
        <transition name="fade">
          <div class="img-view">
            <!-- 遮罩层 -->
            <div class="img-layer"></div>
            <div class="img">
              <img class="bigImg" :src="imgSrc">
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        props: ['imgName', 'imgSrc'],
        methods: {
            closeFn(){
                this.$emit('closeFn')
            },
        }
    }
</script>
<style scoped lang="scss">
  .img_preview_wrap{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 2000;
    .img_preview_box{
      width: 960px;
      height: 540px;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      background: rgba(0,0,0,0.6);
      .img_head{
        width: 960px;
        height: 32px;
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 10;
        .img_name{
          /*width: 600px;*/
          font-size: 12px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 32px;
          margin-left: 20px;
        }
        .close_btn{
          color: #ffffff;
          font-size: 20px;
          margin-right: 10px;
          cursor: pointer;
        }
      }
      .img-box{
        width: 960px;
        transform: translateY(0);
        display: flex;
        min-height: 200px;
        height: 100%;
        text-align: center;
        >img{
          cursor: zoom-in;
        }
      }
    }
  }
  /*动画*/
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .bigImgbox {
    max-width: 420px;
  }
  .img-view {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    /*overflow-y: scroll;*/
    cursor: zoom-out;
  }

  /*遮罩层样式*/
  .img-view .img-layer {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    /*width: 100%;*/
    height: 100%;
    overflow-x: hidden;
  }
  .img-view .img {
    height: 540px;
    display: flex;
    justify-content: center;
    align-items: center;
    /*width: 100vw;*/
    /*height: 100vh;*/
    /*overflow: auto;*/
    margin: auto;
  }
  /*不限制图片大小，实现居中*/
  .img-view .img img {
    max-width: 940px;
    max-height: 470px;
    display: block;
    margin: auto;
    z-index: 111111;
    object-fit: cover;
    /*overflow-y: scroll;*/
  }

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/imgView.vue